import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { getCourse, getAllCourses } from 'services/course';
import Content from 'services/course/models/content-interface';
import Course from 'services/course/models/course-interface';
import Author from 'services/profissionals/models/author-interface';
import Product from 'services/product/models/product-interface';

import { ModulesContentWrapper, ModulesCard, ModuleMainBtn } from './style';
import IconPregnant from 'assets/icon/icone-gravida.svg';
import IconPlayWhite from 'assets/icon/icone-play-white.svg';
import IconPlayRounded from 'assets/icon/icone-play-rounded.svg';
import IconArrowDown from 'assets/icon/arrow-down-primary.svg';
import IconArrowTop from 'assets/icon/arrow-top-primary.svg';
import smoothscroll from 'smoothscroll-polyfill';
import { Loading } from 'components';
import { SectionContainer } from 'components/Container';
import { ICoursesUserTrail } from 'services/course/models/trail-interface';

smoothscroll.polyfill();

interface IMyCourseParams {
  courseId: string;
  trailId: string;
}

interface ICourseData {
  progress: number;
  userName: string;
  titleCourse: string;
  thumbnail: string;
  lessonId: string;
}

const ModulesContent: React.FC = () => {
  const [allModules, setAllModules] = useState<Array<Course>>([]);
  const [openedModule, setOpenedModule] = useState<string>('');
  const [currentModule, setCurrentModule] = useState<ICoursesUserTrail>();
  const [trailId, setTrailId] = useState<string>();
  const history = useHistory();

  const isLoading = useMemo(() => {
    return !allModules.length;
  }, [allModules]);

  const handleCoursesLoad = useCallback(async () => {
    try {
      const localCourses = await getAllCourses();

      if (localCourses && localCourses.length > 0) {
        const localCourse = await getCourse(localCourses[0].trail_id);
        setTrailId(localCourse.trail_id);
        setAllModules(localCourse.courses);

        const sortCourse = localCourse?.user?.courses
          ?.filter(course => !!course.start_at && !course.finish_at)
          .sort((a, b) => {
            let date1 = new Date(a.start_at);
            let date2 = new Date(b.start_at);

            if (date1 < date2) return 1;
            if (date1 > date2) return -1;
            return 0;
          });

        if (sortCourse && sortCourse.length > 0) {
          setCurrentModule(sortCourse[0]);
        } else {
          history.push('/home');
        }
      } else {
        history.push('/home');
      }
    } catch (error) {
      console.error('Erro ao carregar cursos:', error);
      history.push('/home');
    }
  }, [history]);

  useEffect(() => {
    handleCoursesLoad();
  }, [handleCoursesLoad]);

  useEffect(() => {
    if (currentModule) {
      handleToggleModule(currentModule.course_id);
    }
  }, [currentModule]);

  const goToLesson = (courseId: string, lessonId: string) => {
    history.push(`/trilha/${trailId}/curso/${courseId}/aula/${lessonId}`);
  };

  const handleToggleModule = (courseId: string) => {
    setOpenedModule(openedModule === courseId ? '' : courseId);
  };

  return !isLoading ? (
    <ModulesContentWrapper>
      <SectionContainer>
        <div className="title">
          <h4>Módulos do Programa</h4>
        </div>
        <div className="modules">
          {allModules.length &&
            allModules.map((module, index) => (
              <ModulesCard key={index} open={openedModule === module.course_id}>
                <div className="module-content">
                  <div className="image-wrapper">
                    <img src={IconPregnant} alt="icon" />
                  </div>
                  <div className="module-info">
                    <h5 className="module-title">{module.title}</h5>
                    <span className="module-description">
                      {module.description}
                    </span>
                    {index === 0 && (
                      <p>
                        Cuidados essenciais na saúde física, emocional e
                        preparações iniciais da gestante.
                      </p>
                    )}
                    {index === 1 && (
                      <p>
                        Cuidados para preparar o corpo, a mente e o enxoval para
                        a chegada do bebê.
                      </p>
                    )}
                    {index === 2 && (
                      <p>
                        Tudo o que você precisa saber e fazer nas semanas finais
                        antes do bebê.
                      </p>
                    )}
                    {index === 3 && (
                      <p>
                        Orientações essenciais para cuidar do bebê e da mãe nos
                        primeiros meses.
                      </p>
                    )}
                    <p></p>
                  </div>
                  <div className="module-actions">
                    <span className="material-type">
                      {module.contents.length} aulas
                    </span>
                    <ModuleMainBtn
                      onClick={() => {
                        goToLesson(
                          module.course_id,
                          module.contents[0].content_id,
                        );
                      }}
                    >
                      <img src={IconPlayWhite} alt="Play" /> Assistir aulas
                    </ModuleMainBtn>
                  </div>
                </div>
                {module.contents.length && (
                  <div className="lessons-list">
                    {module.contents.map((lesson, i) => (
                      <div
                        key={i}
                        className="lesson"
                        onClick={() => {
                          goToLesson(module.course_id, lesson.content_id);
                        }}
                      >
                        <img src={IconPlayRounded} alt="Play" />
                        <span>{lesson.title}</span>
                      </div>
                    ))}
                  </div>
                )}
                <div className="open-lessons">
                  <span onClick={() => handleToggleModule(module.course_id)}>
                    {openedModule === module.course_id ? (
                      <>
                        Fechar aulas
                        <img src={IconArrowTop} alt="Arrow up" />
                      </>
                    ) : (
                      <>
                        Veja quais são as aulas
                        <img src={IconArrowDown} alt="Arrow down" />
                      </>
                    )}
                  </span>
                </div>
              </ModulesCard>
            ))}
        </div>
      </SectionContainer>
    </ModulesContentWrapper>
  ) : (
    <Loading />
  );
};

export default ModulesContent;
